import React from 'react'
import Table from '../Table/Table'
import NotificationModal from '../NotificationModal/NotificationModal'
import { Route, Routes, Link } from 'react-router-dom';

function MainLayout() {

  return (
    <>
        <Routes>
          <Route path="/" element={<Table />} />
          <Route path="/notification-modal" element={<NotificationModal />} />
        </Routes>
    </>
  )
}

export default MainLayout;
